<button class="close-button" mat-icon-button (click)="cancel()">
    <mat-icon>close</mat-icon>
</button>
<h2 mat-dialog-title>Distance</h2>
<mat-dialog-content>
    <div class="distance-input">
        <input
            type="number"
            min="0"
            [formControl]="distance"
            (ngModelChange)="distance.updateValueAndValidity()"
            aria-label="distance"
        />
        <span>Miles</span>
    </div>
    <small *ngIf="invalid$ | async">
        Please check your input, value is not valid
    </small>
</mat-dialog-content>
<mat-dialog-actions align="center">
    <button class="medium-round" mat-raised-button [disabled]="invalid$ | async" (click)="assent()">
        Save
    </button>
    <button class="medium-round" mat-raised-button (click)="reset()">Reset</button>
</mat-dialog-actions>
